import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import {
  PageContainer,
  ContentGrid,
  ContentRow,
  Card,
  CardTitle,
  CardContent,
  ActionBar,
  Button,
  SearchInput,
  Table,
  TableHeader,
  TableRow,
  TableCell,
  StatusBadge,
  TabContainer,
  TabList,
  Tab,
  TabContent,
  fadeIn
} from '../styles/PageStyles';
import PageHeaderWithInfo from '../components/common/PageHeaderWithInfo';
import { faHurricane } from '@fortawesome/free-solid-svg-icons';
import { getExecutionPipelineCount, getPipelineRuns } from '../services/pipelineService';
import { useNavigate } from 'react-router-dom';
import { formatDate } from '../utils/dateUtils';
import Pagination from '../components/common/Pagination';

const UnderwritingHub = () => {

  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [pipelineList, setPipelineList] = useState([]);
  const [activeTab, setActiveTab] = useState('applications');

   const [totalPages, setTotalPages] = useState(0);
   const [totalItems, setTotalItems] = useState(0);
   const [currentPage, setCurrentPage] = useState(1);
    
   const itemsPerPage = 10;

  useEffect(() => {
    const fetchUnderWritingPipelines = async () => {

      const filters = { "value_stream": "New Business" };
      const sort = {};
      const query = `skip=${(currentPage - 1) * itemsPerPage}&limit=${itemsPerPage}`;
      try {
        const response = await getPipelineRuns(filters, sort, query);
        setPipelineList(response || []);
      } catch (error) {
        console.error('Error fetching user data:', error);
        // navigate('/login'); // Redirect to login if unauthorized
      }
    };
    fetchUnderWritingPipelines();
  }, [navigate, currentPage]);



  useEffect(() => {
    const fetchAndSetPipelineCount = async () => {
      try {
        const filter = { "value_stream": "New Business" }
        const count = await getExecutionPipelineCount(filter);
        console.log({totalItems})
        setTotalItems(count);
      } catch (error) {
        console.log("Error while fetching pipeline data", error);
      }
    };

    fetchAndSetPipelineCount();
  }, []);
  
  // Mock data for underwriting applications
  const applications = [
    { id: 'APP-001', applicant: 'John Smith', type: 'Life Insurance', risk: 'medium', status: 'in-review', date: '2025-03-15', score: 78 },
    { id: 'APP-002', applicant: 'Emily Johnson', type: 'Health Insurance', risk: 'low', status: 'approved', date: '2025-03-14', score: 92 },
    { id: 'APP-003', applicant: 'Michael Davis', type: 'Auto Insurance', risk: 'high', status: 'pending', date: '2025-03-16', score: 61 },
    { id: 'APP-004', applicant: 'Sarah Wilson', type: 'Home Insurance', risk: 'low', status: 'approved', date: '2025-03-13', score: 88 },
    { id: 'APP-005', applicant: 'Robert Brown', type: 'Life Insurance', risk: 'medium', status: 'in-review', date: '2025-03-17', score: 75 },
  ];

  // Filter applications based on search term
  const filteredApplications = applications.filter(app =>
    app.id.toLowerCase().includes(searchTerm.toLowerCase()) ||
    app.applicant.toLowerCase().includes(searchTerm.toLowerCase()) ||
    app.type.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Get risk badge color
  const getRiskColor = (risk) => {
    switch (risk) {
      case 'low': return 'active';
      case 'medium': return 'warning';
      case 'high': return 'error';
      default: return 'default';
    }
  };

  // Get status badge color
  const getStatusColor = (status) => {
    switch (status) {
      case 'approved': return 'active';
      case 'pending': return 'default';
      case 'in-review': return 'warning';
      case 'rejected': return 'error';
      default: return 'default';
    }
  };

  const handleViewUnderwriting = (underwritingId) => {
    navigate(`/workstream-details/${underwritingId}`);
  };
  const formatDateTime = (dateValue) => {
    const date = dateValue instanceof Date ? dateValue : new Date(dateValue);
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const compareDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());

    const timeOptions = {
      hour: 'numeric',
      minute: '2-digit',
      second: '2-digit',
      hour12: true
    };

    // If it's today, just show time
    if (compareDate.getTime() === today.getTime()) {
      return date.toLocaleTimeString(undefined, timeOptions);
    }

    // If it's a different day, show day and month with time
    const dayOptions = {
      day: '2-digit',
      month: 'short',
      hour: 'numeric',
      minute: '2-digit',
      second: '2-digit',
      hour12: true
    };

    return date.toLocaleString(undefined, dayOptions);
  };
  return (
    <PageContainer>
      <motion.div
        initial="hidden"
        animate="visible"
        variants={fadeIn}
      >
        <PageHeaderWithInfo
          icon={faHurricane}
          title="New Business"
          description="AI-powered underwriting platform that analyzes applicant data, assesses risk profiles, and provides 
          recommendations for insurance policy approvals and pricing."
        >
          <div style={{ display: 'flex', gap: '1rem' }}>
            {activeTab === 'applications' && (
              <SearchInput
                type="text"
                placeholder="Search claims..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            )}

            <Button primary>New Application</Button>
          </div>
        </PageHeaderWithInfo>
        {/* 

        <TabContainer>
          <TabList>
            <Tab active={activeTab === 'applications'} onClick={() => setActiveTab('applications')}>Applications</Tab>
            <Tab active={activeTab === 'models'} onClick={() => setActiveTab('models')}>Risk Models</Tab>
            <Tab active={activeTab === 'analytics'} onClick={() => setActiveTab('analytics')}>Analytics</Tab>
          </TabList> */}

        <TabContainer>
          <TabContent active={activeTab === 'applications'}>
          {/* <ActionBar>
              <SearchInput 
                type="text" 
                placeholder="Search applications..." 
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <Button>Filter</Button>
              <Button>Sort</Button>
            </ActionBar> */}
          {/*             
            <ContentGrid>
              <Card>
                <CardTitle>Applications Overview</CardTitle>
                <CardContent>
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '1rem' }}>
                    <div>
                      <div style={{ fontSize: '2rem', fontWeight: 'bold', color: 'var(--primary)' }}>57</div>
                      <div style={{ fontSize: '0.8rem', color: 'var(--text-secondary)' }}>Total Applications</div>
                    </div>
                    <div>
                      <div style={{ fontSize: '2rem', fontWeight: 'bold', color: '#FFCC00' }}>23</div>
                      <div style={{ fontSize: '0.8rem', color: 'var(--text-secondary)' }}>In Review</div>
                    </div>
                    <div>
                      <div style={{ fontSize: '2rem', fontWeight: 'bold', color: '#34C759' }}>29</div>
                      <div style={{ fontSize: '0.8rem', color: 'var(--text-secondary)' }}>Approved</div>
                    </div>
                    <div>
                      <div style={{ fontSize: '2rem', fontWeight: 'bold', color: '#FF3B30' }}>5</div>
                      <div style={{ fontSize: '0.8rem', color: 'var(--text-secondary)' }}>Rejected</div>
                    </div>
                  </div>
                </CardContent>
              </Card>
              
              <Card>
                <CardTitle>Risk Distribution</CardTitle>
                <CardContent>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                    <div>
                      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.3rem' }}>
                        <span>Low Risk</span>
                        <span>42%</span>
                      </div>
                      <div style={{ width: '100%', height: '8px', background: 'rgba(0,102,255,0.1)', borderRadius: '4px' }}>
                        <div style={{ width: '42%', height: '8px', background: '#34C759', borderRadius: '4px' }}></div>
                      </div>
                    </div>
                    
                    <div>
                      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.3rem' }}>
                        <span>Medium Risk</span>
                        <span>35%</span>
                      </div>
                      <div style={{ width: '100%', height: '8px', background: 'rgba(0,102,255,0.1)', borderRadius: '4px' }}>
                        <div style={{ width: '35%', height: '8px', background: '#FFCC00', borderRadius: '4px' }}></div>
                      </div>
                    </div>
                    
                    <div>
                      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.3rem' }}>
                        <span>High Risk</span>
                        <span>23%</span>
                      </div>
                      <div style={{ width: '100%', height: '8px', background: 'rgba(0,102,255,0.1)', borderRadius: '4px' }}>
                        <div style={{ width: '23%', height: '8px', background: '#FF3B30', borderRadius: '4px' }}></div>
                      </div>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </ContentGrid> */}

          <Card
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
          >
            {/* <CardTitle>Recent Applications</CardTitle> */}
            <Table>
              <thead>
                <tr>
                  <TableHeader>Name</TableHeader>
                  <TableHeader>Description</TableHeader>
                  <TableHeader>Created Date</TableHeader>
                  <TableHeader>Status</TableHeader>
                  <TableHeader>Actions</TableHeader>
                </tr>
              </thead>
              <tbody>
                {pipelineList.map(app => (
                  <TableRow key={app.id}>
                    <TableCell>{app.name}</TableCell>
                    <TableCell>{app.transaction_description}</TableCell>
                    <TableCell>{formatDate(app.created_at, {format:'dateTime'})}</TableCell>
                    <TableCell>
                      <StatusBadge status={getRiskColor(app.transaction_status)}>
                        {app.transaction_status}
                      </StatusBadge>
                    </TableCell>
                    <TableCell>
                      <Button
                        primary
                        onClick={() => handleViewUnderwriting(app.id)}
                        style={{ padding: '0.4rem 0.8rem', fontSize: '0.8rem' }}
                      >
                        View
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </tbody>
            </Table>
          </Card>
          <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                totalCount={totalItems}
                setCurrentPage={setCurrentPage}
                setTotalPages={setTotalPages}
            />
        </TabContent>

        <TabContent active={activeTab === 'models'}>
          <ContentRow>
            <Card style={{ flex: '1', minWidth: '300px' }}>
              <CardTitle>Active Risk Models</CardTitle>
              <Table>
                <thead>
                  <tr>
                    <TableHeader>Model Name</TableHeader>
                    <TableHeader>Type</TableHeader>
                    <TableHeader>Accuracy</TableHeader>
                    <TableHeader>Last Updated</TableHeader>
                    <TableHeader>Status</TableHeader>
                  </tr>
                </thead>
                <tbody>
                  <TableRow>
                    <TableCell>Life Insurance Risk Model v2.3</TableCell>
                    <TableCell>Regression</TableCell>
                    <TableCell>94.2%</TableCell>
                    <TableCell>2025-03-10</TableCell>
                    <TableCell><StatusBadge status="active">Active</StatusBadge></TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Health Risk Assessment Model</TableCell>
                    <TableCell>Classification</TableCell>
                    <TableCell>91.7%</TableCell>
                    <TableCell>2025-03-05</TableCell>
                    <TableCell><StatusBadge status="active">Active</StatusBadge></TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Property Risk Evaluator</TableCell>
                    <TableCell>Ensemble</TableCell>
                    <TableCell>89.5%</TableCell>
                    <TableCell>2025-02-28</TableCell>
                    <TableCell><StatusBadge status="active">Active</StatusBadge></TableCell>
                  </TableRow>
                </tbody>
              </Table>
            </Card>
            <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                totalCount={totalItems}
                setCurrentPage={setCurrentPage}
                setTotalPages={setTotalPages}
            />
          </ContentRow>
        </TabContent>

        <TabContent active={activeTab === 'analytics'}>
          <ContentGrid>
            <Card>
              <CardTitle>Approval Rate Trends</CardTitle>
              <CardContent>
                <div style={{ height: '200px', display: 'flex', alignItems: 'flex-end', gap: '12px', marginTop: '20px' }}>
                  {[65, 72, 68, 75, 82, 79, 85].map((value, index) => (
                    <div key={index} style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                      <div style={{ height: `${value * 1.5}px`, width: '100%', background: 'var(--primary)', borderRadius: '4px 4px 0 0' }}></div>
                      <div style={{ fontSize: '0.7rem', marginTop: '5px' }}>{`W${index + 1}`}</div>
                    </div>
                  ))}
                </div>
                <div style={{ textAlign: 'center', marginTop: '10px', fontSize: '0.8rem', color: 'var(--text-secondary)' }}>
                  Last 7 Weeks
                </div>
              </CardContent>
            </Card>

            <Card>
              <CardTitle>Processing Efficiency</CardTitle>
              <CardContent>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', marginTop: '20px' }}>
                  <div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.3rem' }}>
                      <span>Manual Processing</span>
                      <span>27%</span>
                    </div>
                    <div style={{ width: '100%', height: '8px', background: 'rgba(0,102,255,0.1)', borderRadius: '4px' }}>
                      <div style={{ width: '27%', height: '8px', background: '#8E8E93', borderRadius: '4px' }}></div>
                    </div>
                  </div>

                  <div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.3rem' }}>
                      <span>AI-Assisted</span>
                      <span>45%</span>
                    </div>
                    <div style={{ width: '100%', height: '8px', background: 'rgba(0,102,255,0.1)', borderRadius: '4px' }}>
                      <div style={{ width: '45%', height: '8px', background: '#FFCC00', borderRadius: '4px' }}></div>
                    </div>
                  </div>

                  <div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.3rem' }}>
                      <span>Fully Automated</span>
                      <span>28%</span>
                    </div>
                    <div style={{ width: '100%', height: '8px', background: 'rgba(0,102,255,0.1)', borderRadius: '4px' }}>
                      <div style={{ width: '28%', height: '8px', background: '#34C759', borderRadius: '4px' }}></div>
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>
            <Pagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  totalCount={totalItems}
                  setCurrentPage={setCurrentPage}
                  setTotalPages={setTotalPages}
              />
          </ContentGrid>
        </TabContent>
      </TabContainer>
    </motion.div>
    </PageContainer >
  );
};

export default UnderwritingHub;
